<script>
	import FeedbackList from "./components/FeedbackList.svelte";
	import FeedbackStats from './components/FeedbackStats.svelte'
	import Form from './components/Form.svelte'

</script>

<main class="container">
	<Form />
	<FeedbackStats />
	<FeedbackList />
</main>

